/**
 * 문제집 진도 배지 컴포넌트
 * 완료/진행중/마감 상태 표시
 */

import React from 'react';

/**
 * ProgressBadge 컴포넌트 Props
 */
interface ProgressBadgeProps {
  /** 완료 여부 */
  isCompleted: boolean;
  /** 마감일 (ISO 8601 문자열) */
  dueDate: string | null;
}

/**
 * 진도 배지 컴포넌트
 *
 * - 완료: 녹색 배지 (✓ 완료)
 * - 마감: 빨간색 깜빡임 배지 (⚠ 마감)
 * - 진행중: 파란색 배지 (📝 진행중)
 */
export const ProgressBadge: React.FC<ProgressBadgeProps> = ({
  isCompleted,
  dueDate,
}) => {
  // 완료 상태
  if (isCompleted) {
    return (
      <div
        className="flex items-center gap-2 px-3 py-1
                    bg-[#00ff88] text-black rounded-sm
                    font-pixel text-xs
                    shadow-[2px_2px_0px_0px_rgba(0,0,0,0.3)]"
      >
        ✓ 완료
      </div>
    );
  }

  // 마감일 체크
  const isOverdue = dueDate && new Date(dueDate) < new Date();

  // 마감된 경우
  if (isOverdue) {
    return (
      <div
        className="flex items-center gap-2 px-3 py-1
                    bg-[#ff6b6b] text-white rounded-sm
                    font-pixel text-xs animate-pulse
                    shadow-[2px_2px_0px_0px_rgba(0,0,0,0.3)]"
      >
        ⚠ 마감
      </div>
    );
  }

  // 진행중
  return (
    <div
      className="flex items-center gap-2 px-3 py-1
                  bg-[#0f3460] text-[#9bbc0f] rounded-sm
                  font-pixel text-xs
                  shadow-[2px_2px_0px_0px_rgba(0,0,0,0.3)]"
    >
      📝 진행중
    </div>
  );
};
